import React from "react";

export type RecapType = "stripe" | "cash" | "booking";

interface Props {
  value: RecapType;
  onChange: (t: RecapType) => void;
}

const RecapTypeTabs: React.FC<Props> = ({ value, onChange }) => {
  const items: RecapType[] = ["stripe", "cash", "booking"];
  const label = (t: RecapType) => t.charAt(0).toUpperCase() + t.slice(1);
  return (
    <div className="flex gap-4 mb-4">
      {items.map((type) => (
        <button
          key={type}
          className={`px-3 py-1 rounded ${value === type ? "bg-blue-500 text-white" : "bg-gray-200"}`}
          onClick={() => onChange(type)}
          type="button"
        >
          {label(type)}
        </button>
      ))}
    </div>
  );
};

export default RecapTypeTabs;
